import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormControl} from '@angular/forms';

import {ModalComponent} from '../../modal';
import {RequestStatus} from '../workflow-v2.interface';
import {OnboardingStatus} from '../../../onboarding/onboarding.model';

export interface CancelWorkflowAssignee {
  fullName: string;
  employeeNumber?: string;
}

export interface CancelWorkflowDetails {
  workflowType: string;
  workflowSubject: string;
  workflowStatus: RequestStatus | OnboardingStatus;
  workflowAssignee: string;
  workflowAssignees?: CancelWorkflowAssignee[];
  subjectEmployeeNumber: string;
  assigneeEmployeeNumber: string;
  requestId: string;
}

@Component({
  selector: 'gp-cancel-workflow-modal',
  templateUrl: './cancel-workflow-modal.component.html',
  styleUrls: ['./cancel-workflow-modal.component.scss']
})
export class CancelWorkflowModalComponent {

  @Input()
  public cancelWorkflowDetails: CancelWorkflowDetails;

  @Output()
  public onCancelWorkflow: EventEmitter<{id: string, comment: string}> = new EventEmitter();
  public comment = new FormControl('');

  public cancelWorkflow(modalRef: ModalComponent) {
    modalRef.close();
    this.onCancelWorkflow.emit({id: this.cancelWorkflowDetails.requestId, comment: this.comment.value});
    this.comment.reset('');
  }

}
